// extracted by mini-css-extract-plugin
module.exports = {"container":"candidate_container__MToxM","tabSection":"candidate_tabSection__uwDMK","ListBodyContainer":"candidate_ListBodyContainer__3QjDz","export":"candidate_export__3aXgn"};